<div class="pt-3" [id]="id">
  <h3 class="border-bottom" *scText="rendering.fields.heading"></h3>
  <sc-placeholder
    name="jss-styleguide-section"
    [rendering]="rendering"
  ></sc-placeholder>
</div>
